import { Component, Input } from '@angular/core';

@Component({
  selector: 'lm-menu-security-info',
  templateUrl: 'lm-menu-security-info.component.html',
  styleUrls: [ 'lm-menu-security-info.component.scss' ],
  })

export class LMMenuSecurityInfoComponent  {

  @Input() lmWebAppComponent: LMWebAppComponent;
  @Input() lmWebAppComponentItem: LMWebAppComponentItem;

  constructor() {
  }
}

